import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import Button from '../../../../../components/button';
import Typography from '../../../../../components/typography';
import ContentSection from '../../../../../components/contentSection';
import StepProgressBar from '../../../../../components/stepProgressBar';
import BalanceErrorInNotifications from '../../../../../components/balanceErrorInNotifications';
import NotificationsSettings from '../../../../../components/notificationsSettings/notificationsSettings';

import { showDependingOnBusinessFlag } from '../../../../../utils/businessFlag';
import calculateToNotificationsPrice from '../../../../../utils/calculateTonotificationsPrice';

import './selectAndPayNotifications.scss';

const selectAndPayNotifications = ({
  next, user,
  onChange, businessFlags, currentBalance,
  step, currentStep, totalPriceNotifications, setTotalPriceNotifications,
}) => {
  const [errorBalanceInNotification, setErrorBalanceInNotification] = useState(false);
  const [totalNotifications, setTotalNotifications] = useState(0);

  return (
    <ContentSection>
      <div className="progressBar">
        <StepProgressBar
          steps={[{}, {}, {}, {}].map((item, index) => {
            const newItem = item;
            if (index < step) newItem.success = true;
            return newItem;
          })}
          currentStep={currentStep}
        />
        <Typography
          className="notifications-settings__title"
          type="paragraph"
          style={{
            fontFamily: 'Ubuntu',
            fontWeight: 400,
            fontStyle: 'italic',
            fontSize: '18px',
            lineHeight: '100%',
            letterSpacing: '0%',
            marginTop: '35px',
            textAlign: 'left',
            color: 'gray',
            width: '92%',
          }}
          text="Activa notificaciones de seguimiento para tus destinatarios"
        />
      </div>
      <div className="container__content-data-to-payment">
        {showDependingOnBusinessFlag({ businessFlags, section: 'notificationsSettings' })
              && (
                <div className="notifications-settings">
                  <NotificationsSettings
                    onChange={(notifications) => {
                      const shippingInfo = {
                        deliverySelected: {
                          negotiation: false,
                        },
                      };
                      const response = calculateToNotificationsPrice(notifications, shippingInfo, 'mp');
                      setTotalPriceNotifications(
                        response.sumWithInitial,
                      );
                      setTotalNotifications(response.listCodeNotificationsLength);
                      onChange(notifications);
                    }}
                    hiddeToolTip
                  />
                </div>
              )}
        <Button
          type="quaternary"
          onClick={() => {
            if (totalPriceNotifications <= currentBalance) {
              next();
            } else if (
              (totalPriceNotifications) <= user.creditLimitCop
            ) {
              next();
            }
          }}
          className="flotant-button"
          text={`Notificaciones activas ${totalNotifications}`}
        />
      </div>
      {errorBalanceInNotification && (
      <BalanceErrorInNotifications
        onChangeBack={() => setErrorBalanceInNotification(!errorBalanceInNotification)}
        countryCode={user.countryCode}
      />
      )}
    </ContentSection>
  );
};

selectAndPayNotifications.propTypes = {
  next: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  currentBalance: PropTypes.number.isRequired,
  loadingSendingGenerating: PropTypes.bool.isRequired,
  rechargeBalance: PropTypes.func.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  user: PropTypes.shape.isRequired,
  onChange: PropTypes.func.isRequired,
  businessFlags: PropTypes.shape().isRequired,
  step: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalPriceNotifications: PropTypes.number.isRequired,
  setTotalPriceNotifications: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  businessFlags: state.globalData.businessFlags || [],
});

export default compose(connect(mapStateToProps))(selectAndPayNotifications);
